import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class DeviceService {

  readonly hasCoarsePointer = window.matchMedia('(pointer:coarse)').matches;

  get tooltipEvent() {
    return this.hasCoarsePointer ? 'focus' : 'hover';
  }
}